// Lightweight replacement for the `lodash.pick` package to avoid a vulnerable
// third-party dependency. Creates a new object composed of the picked
// top-level properties that exist on the source object.
export default function pick(object, ...paths) {
	const keys = paths.reduce(
		(acc, path) => acc.concat(Array.isArray(path) ? path : [path]),
		[]
	);

	const result = {};

	if (object === null || object === undefined) {
		return result;
	}

	keys.forEach(key => {
		if (Object.prototype.hasOwnProperty.call(object, key)) {
			result[key] = object[key];
		}
	});

	return result;
}
